import { render } from "./MarketPlaceDeployVM.vue?vue&type=template&id=276dc7b5&scoped=true"
import script from "./MarketPlaceDeployVM.vue?vue&type=script&lang=js"
export * from "./MarketPlaceDeployVM.vue?vue&type=script&lang=js"

import "./MarketPlaceDeployVM.vue?vue&type=style&index=0&id=276dc7b5&scoped=true&lang=css"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-276dc7b5"]])

export default __exports__